module.exports = __webpack_public_path__ + "static/Kicks-1e92f44cf2ab8cfb9a99623fd751c1f6.webp";